import { z } from "zod";

export const DELIVERY_TARGET_HOURS = { download: 2, processing: 6, eligible: 48 } as const;
export const TIMELINESS_MIN_SAMPLE = 20;

/** Stages and statuses that make a download problem, as on the Platforms tab and the backlog link. */
export const DOWNLOAD_PROBLEM = { stage: ["download", "archive"], status: ["failed", "waiting"] } as const;

export function backlogHref(params: Record<string, string | undefined>): string {
  // QO-35: counts include other accounts' X posts, which the backlog hides by default, so a count opens them too.
  const all = params["counted"] === "yes" && params["person"] === undefined;
  const merged: Record<string, string | undefined> = { ...params, ...(all ? { authors: "all" } : {}) };
  const query = new URLSearchParams(Object.entries(merged).filter((e): e is [string, string] => e[1] !== undefined));
  return `/backlog?${query.toString()}`;
}

const countLinkSchema = z.strictObject({ count: z.number().int().nonnegative(), href: z.string() });

export const platformTotalsSchema = z.strictObject({
  key: z.string(),
  label: z.string(),
  href: z.string(),
  sources: z.number().int().nonnegative(),
  paused: z.number().int().nonnegative(),
  communications: countLinkSchema,
  items: countLinkSchema,
  media_seconds: z.number().nonnegative(),
  pages: z.number().int().nonnegative(),
  archive_bytes: z.number().nonnegative(),
  deleted_contributing: z.number().int().nonnegative(),
  weekly_items: z.number().nonnegative(),
  weekly_bytes: z.number().nonnegative(),
});
export type PlatformTotals = z.infer<typeof platformTotalsSchema>;

export const platformTableSchema = z.strictObject({
  rows: z.array(platformTotalsSchema),
  not_collected: z.array(
    z.strictObject({ key: z.string(), label: z.string(), accounts: z.number().int().nonnegative() }),
  ),
  total: platformTotalsSchema.omit({ key: true, label: true, href: true }),
});
export type PlatformTable = z.infer<typeof platformTableSchema>;
